import { useEffect, useMemo } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $specialOffersStore } from '@lib/store';
import { LsbUtils, RoutePaths } from '@shared/utils';
import { Offer } from './widgets';
import { PageContainer, View } from '@widgets';

export const ConciergeOfferPage = () => {
  const { type, offerId } = useParams<{ type: string; offerId: string }>();

  const specialOffersStore = useUnit($specialOffersStore.store);

  const { t } = useTranslation('concierge');

  useEffect(() => {
    $specialOffersStore.events.getSpecialOffers();
    return () => $specialOffersStore.events.clear();
  }, []);

  const offer = useMemo(() => LsbUtils.getSpecialOfferById({ id: offerId!, offers: specialOffersStore.data }), [offerId, specialOffersStore.data]);

  if (!specialOffersStore.loading && offer == null) return <Navigate to={RoutePaths.concierge.onNavigate()} replace />;
  return (
    <PageContainer
      className='flex flex-col gap-6'
      title={offer?.header}
      back
      backText={t('backText')}
      to={RoutePaths.conciergeRequest.onNavigate(type!)}
    >
      <View
        loading={specialOffersStore.loading}
        noData={!offer}
        error={specialOffersStore.error}
        onRefresh={() => $specialOffersStore.events.getSpecialOffers()}
      >
        <Offer type={type!} offer={offer!} />
      </View>
    </PageContainer>
  );
};
